import { createContext } from "react";
import { Cart, Product, ShippingData } from "@/interfaces";

export interface CartContextProps {
  cart?: Cart;
  add?: (
    item?: Product,
    shippingFee?: number,
    claimFee?: number,
    coopEligible?: number,
    couponAmount?: number,
    isOffSite?:boolean
  ) => void;
  remove?: (id?: number) => void;
  setQuantity?: (id?: number, value?: number,type?: "in-store"|"shipping") => void;
  setCoopApplied?: (id?: number, value?: number) => void;
  setShippingFee?: (value?: number) => void;
  setDiscount?: (value?: number,isOffSite?:boolean) => void;
  setDiscountTypeWithCartType?: (props:Cart["discountConfig"]) => void;
  setSelectedToShip?: (id?: number, value?: boolean) => void;
  setShippingQuantity?: (id?: number, value?: number) => void;
  setInStoreQuantity?: (id?: number, value?: number) => void;
  setShippingData?: (shippingData?: ShippingData) => void;
  setCard?: (cardNumber?: string, expiration?: string) => void;
  clear?: () => void;
  setOrderId?: (id?: number) => void;
  setCouponAmount?: (value?: number) => void;
  setCouponQuantity?: (value?: number) => void;
  setCart?: (cart?: Cart) => void;
  setProductPrice: (id?: number, value?: number) => void;
  setDiscountComment?: (comment?: string) => void;
}

export const CartContext = createContext<CartContextProps>({
  cart: undefined,
  add: () => undefined,
  remove: () => undefined,
  setQuantity: () => undefined,
  setCoopApplied: () => undefined,
  setShippingFee: () => undefined,
  setDiscount: () => undefined,
  setSelectedToShip: () => undefined,
  setShippingQuantity: () => undefined,
  setInStoreQuantity: () => undefined,
  setShippingData: () => undefined,
  setCard: () => undefined,
  clear: () => undefined,
  setOrderId: () => undefined,
  setCouponAmount: () => undefined,
  setCouponQuantity: () => undefined,
  setCart: () => undefined,
  setProductPrice: () => undefined,
  setDiscountComment: () => undefined,
});
